module.exports = __webpack_public_path__ + "media/04.7adc7afb.mp3";